<app-search-widget-toppage-wrapper
  [pageType]="pageType"
></app-search-widget-toppage-wrapper>

<div class="narrowed-container">
  <div class="row">
    <div class="col">
      <app-breadcrumbs [breadcrumbs]="breadcrumbs"></app-breadcrumbs>
    </div>
  </div>
  <div class="row">
    <div class="col prose">
      <div
        *ngIf="post"
        [dataLayerParamsClickGA4]="customGa4Params"
        appStaticAdClick
        appStaticRedirectClick
        class="content-pages-single-container"
        id="content-pages-single-container"
      >
        <h1
          [innerHTML]="
            post.title.rendered | wpMediaUrlFix | wpAnchorLinksUrlFix | safeHtml
          "
          class="mt-4 text-3xl text-grey-1 md:text-4xl"
        ></h1>
        <h3
          *ngIf="post.acf.subtitle && post.acf.subtitle !== ''"
          [innerHTML]="
            post.acf.subtitle | wpMediaUrlFix | wpAnchorLinksUrlFix | safeHtml
          "
          class="content-pages-single-subtitle"
        ></h3>

        <div class="content-pages-single-buttons">
          <a
            *ngIf="post.acf.showLogo && post.acf.logoUrlRouterLink !== null"
            [eventAction]="'logo top click'"
            [eventCategory]="adName"
            [eventParams]="
              generateDataLayerParamsClickGA4(adName + ' - logo top click')
            "
            [queryParams]="post.acf.logoUrlQueryParams"
            [routerLink]="post.acf.logoUrlRouterLink"
            [target]="'_self'"
            [title]="'logo'"
            appGtmEvent
            appGtmGa4Event
            class="content-pages-single-logo"
            rel="nofollow"
          >
            <app-media-item [image]="post.acf.logoImage"></app-media-item>
          </a>

          <a
            *ngIf="post.acf.showLogo && post.acf.logoUrlRouterLink === null"
            [eventAction]="'logo top click'"
            [eventCategory]="adName"
            [eventParams]="
              generateDataLayerParamsClickGA4(adName + ' - logo top click')
            "
            [href]="post.acf.logoUrl"
            [target]="'_blank'"
            [title]="'logo'"
            appGtmEvent
            appGtmGa4Event
            class="content-pages-single-logo"
            rel="nofollow"
          >
            <app-media-item [image]="post.acf.logoImage"></app-media-item>
          </a>

          <div class="content-pages-single-buttons-right">
            <app-ui-button
              *ngIf="post.acf.showMoreButton"
              [color]="'secondary'"
              [compressed]="false"
              [eventAction]="'mer om top click'"
              [eventCategory]="adName"
              [eventParams]="
                generateDataLayerParamsClickGA4(adName + ' - mer om top click')
              "
              [expanded]="'inline'"
              [linkTitle]="
                post.acf.moreBtnUrlRouterLink !== null
                  ? null
                  : post.acf.moreBtnLabel
              "
              [linkUrl]="
                post.acf.moreBtnUrlRouterLink !== null
                  ? null
                  : post.acf.moreBtnUrl
              "
              [queryParams]="post.acf.moreBtnUrlQueryParams"
              [routerLink]="post.acf.moreBtnUrlRouterLink"
              [size]="'lg'"
              [target]="
                post.acf.moreBtnUrlRouterLink !== null ? '_self' : '_blank'
              "
              [title]="post.acf.moreBtnLabel"
              appGtmEvent
              appGtmGa4Event
            >
              {{ post.acf.moreBtnLabel }}
            </app-ui-button>

            <a
              *ngIf="post.acf.showAppStoreBtn"
              [eventAction]="'appstore top click'"
              [eventCategory]="adName"
              [eventParams]="
                generateDataLayerParamsClickGA4(
                  adName + ' - appstore top click'
                )
              "
              [href]="post.acf.appStoreBtnUrl"
              appGtmEvent
              appGtmGa4Event
              rel="nofollow"
              target="_blank"
            >
              <img
                [ngSrc]="appStoreImageUrl"
                alt="App Store"
                height="48"
                width="144"
              >
            </a>

            <a
              *ngIf="post.acf.showGooglePlayBtn"
              [eventAction]="'google play top click'"
              [eventCategory]="adName"
              [eventParams]="
                generateDataLayerParamsClickGA4(
                  adName + ' - google play top click'
                )
              "
              [href]="post.acf.googlePlayBtnUrl"
              appGtmEvent
              appGtmGa4Event
              rel="nofollow"
              target="_blank"
            >
              <img
                [ngSrc]="googlePlayImageUrl"
                alt="Google Play"
                height="48"
                width="164"
              >
            </a>
          </div>
        </div>

        <div class="row">
          <div class="col">
            <div
              [innerHtml]="
                post.excerpt.rendered
                  | wpMediaUrlFix
                  | wpAnchorLinksUrlFix
                  | safeHtml
              "
              appAddClickActionToLocalLinks
              class="content-pages-single-description"
            ></div>
            <div class="content-pages-single-creation-date">
              {{ publishDate }}
            </div>
            <div
              [innerHtml]="
                post.content.rendered
                  | wpMediaUrlFix
                  | wpAnchorLinksUrlFix
                  | safeHtml
              "
              appAddClickActionToLocalLinks
              class="content-pages-single-content"
            ></div>
            <div
              *ngIf="post && post.acf && post.acf.caption !== ''"
              [innerHtml]="
                post.acf.caption
                  | wpMediaUrlFix
                  | wpAnchorLinksUrlFix
                  | safeHtml
              "
              appAddClickActionToLocalLinks
              class="content-pages-single-bottom-caption"
            ></div>
          </div>

          <div *ngIf="post.acf.showFacts" class="col-4">
            <div class="boxed">
              <h3>{{ post.acf.factsHeader }}</h3>
              <div
                [innerHTML]="
                  post.acf.factsContent
                    | wpMediaUrlFix
                    | wpAnchorLinksUrlFix
                    | safeHtml
                "
                appAddClickActionToLocalLinks
              ></div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="col-s">
      <app-sidebar
        *ngIf="post"
        [isAdVisible]="true"
        [pageType]="pageType"
      ></app-sidebar>
    </div>
  </div>
</div>
